import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ms from './locales/ms.json';
import en from './locales/en.json';

// Get saved language or default to Bahasa Melayu
const savedLanguage = localStorage.getItem('preferredLanguage') || 'ms';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ms: { translation: ms },
      en: { translation: en }
    },
    lng: savedLanguage, // Use saved language or default to Bahasa Melayu
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
